<template>
    <section id="meublePlano" class="flexContainer fd-c full">
        <section id="meublePlanoWrapper">
            <h2 class="ff-medium uppercase center">{{ $t("meublePlano.title") }}</h2>
            <form class="full">
                <div class="plano flexContainer ai-fs fd-r ai-s">
                    <div class="formBuilder scrollY">
                        <div class="formGroup">
                            <h3 class="ff-medium uppercase label">{{ $t("meublePlano.externalSize") }}</h3>
                            <label class="label block full">{{ $t("meublePlano.name") }}</label> <input class="full" v-model="display.name" />
                            <div class="flexContainer">
                                <div class="size1of2">
                                    <label class="label block full">{{ $t("meublePlano.width") }}</label>
                                    <input class="full" type="number" placeholder="Width" v-model="display.widthExternal" min="0" />
                                </div>
                                <div class="size1of2 divDroite">
                                    <label class="label block full">{{ $t("meublePlano.height") }}</label>
                                    <input class="full" type="number" placeholder="Height" v-model="display.heightExternal" min="0" />
                                </div>
                            </div>
                        </div>
                        <div class="formGroup">
                            <h3 class="ff-medium uppercase label">{{ $t("meublePlano.internalSize") }}</h3>
                            <div class="flexContainer">
                                <div class="size1of2">
                                    <label class="label block full">{{ $t("meublePlano.header") }}</label>
                                    <input class="full" type="number" placeholder="Padding top" v-model="display.front" min="0" />
                                </div>
                                <div class="size1of2 divDroite">
                                    <label class="label block full">{{ $t("meublePlano.footer") }}</label>
                                    <input class="full" type="number" placeholder="Padding bottom" v-model="display.base" min="0" />
                                </div>
                            </div>
                        </div>
                        <div class="formGroup">
                            <h3 class="ff-medium uppercase label">{{ $t("meublePlano.planoModule") }}</h3>
                            <div class="flexContainer">
                                <div class="size1of2">
                                    <label class="label block full">{{ $t("meublePlano.width") }}</label>
                                    <input class="full" type="number" placeholder="Width cadre" v-model="display.widthInternal" min="0" />
                                </div>
                                <div class="size1of2 divDroite">
                                    <label class="label block full">{{ $t("meublePlano.height") }}</label>
                                    <input class="full" type="number" placeholder="Height cadre" v-model="display.heightInternal" min="0" />
                                </div>
                            </div>
                        </div>
                        <div class="formGroup">
                            <h3 class="ff-medium uppercase label">Displayer type</h3>
                            <select
                                id="selectSeg"
                                class="full"
                                v-if="display.hasOwnProperty('displayType') && display.displayType.hasOwnProperty('id')"
                                v-model="display.displayerType.id"
                            >
                                <option :value="null">Select display </option>
                                <option v-for="(type, index) in getDisplayType" :key="index" :value="type.id"> {{ type.name }} </option>
                            </select>
                        </div>
                        <div class="formGroup">
                            <h3 class="ff-medium uppercase label">{{ $t("meublePlano.segmentation") }}</h3>
                            <label class="label block full">{{ $t("meublePlano.stripSize") }}</label>
                            <select id="selectSeg" class="full" v-model="segmentation">
                                <option :value="null">Select taille </option>
                                <option v-for="(option, index) in segList" :key="index" :value="option">{{ option }} </option>
                            </select>
                        </div>
                        <div class="formGroup">
                            <h3 class="ff-medium label uppercase">{{ $t("meublePlano.pitchH") }}</h3>
                            <div class="flexContainer">
                                <div class="size1of2">
                                    <label class="label block full">{{ $t("meublePlano.pitchH") }}</label>
                                    <input
                                        class="full"
                                        type="number"
                                        placeholder="Width pitch"
                                        v-if="display.hasOwnProperty('steps') && display.steps.hasOwnProperty('1')"
                                        v-model="display.steps[1].length"
                                        min="0"
                                    />
                                </div>
                                <div class="size1of2 divDroite">
                                    <label class="label  block full">{{ $t("meublePlano.pitchR") }}</label>
                                    <input
                                        class="full"
                                        type="number"
                                        placeholder="Number of repetitions"
                                        v-if="display.hasOwnProperty('steps') && display.steps.hasOwnProperty('1')"
                                        v-model="display.steps[1].repeat"
                                        min="0"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="formGroup">
                            <h3 class="ff-medium label uppercase">{{ $t("meublePlano.pitchV") }}</h3>
                            <div class="flexContainer">
                                <div class="size1of2">
                                    <label class="label block full">{{ $t("meublePlano.pitchV") }}</label>
                                    <input
                                        class="full"
                                        type="number"
                                        placeholder="Width pitch"
                                        v-if="display.hasOwnProperty('steps') && display.steps.hasOwnProperty('0')"
                                        v-model="display.steps[0].length"
                                        min="0"
                                    />
                                </div>
                                <div class="size1of2 divDroite">
                                    <label class="label block full">{{ $t("meublePlano.pitchR") }}</label>
                                    <input
                                        class="full"
                                        type="number"
                                        placeholder="Number of repetitions"
                                        v-if="display.hasOwnProperty('steps') && display.steps.hasOwnProperty('0')"
                                        v-model="display.steps[0].repeat"
                                        min="0"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="formGroup">
                            <h3 class="ff-medium label uppercase">{{ $t("meublePlano.setBloc") }}</h3>
                            <div class="flexContainer">
                                <div class="size1of2">
                                    <label class="label block full">{{ $t("meublePlano.blocWidth") }}</label>
                                    <input
                                        class="full"
                                        type="number"
                                        placeholder="Width pitch"
                                        v-if="display.hasOwnProperty('blocks') && display.blocks.length !== 0"
                                        v-model="display.blocks[0].length"
                                        min="0"
                                    />
                                    <input class="full" type="number" placeholder="Width pitch" min="0" v-else="" v-model="blockLength" />
                                </div>
                                <div class="size1of2 divDroite">
                                    <label class="label block full">{{ $t("meublePlano.numberOfBlocs") }}</label>
                                    <input
                                        class="full"
                                        type="number"
                                        placeholder="Number of repetitions"
                                        v-if="display.hasOwnProperty('blocks') && display.blocks.length !== 0"
                                        v-model="blockRep"
                                        min="0"
                                    />
                                    <input
                                        class="full"
                                        type="number"
                                        placeholder="Number of repetitions"
                                        min="0"
                                        v-else=""
                                        v-model="blockRepetition"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="planoMeuble">
                        <div id="planoPreview">
                            <div
                                class="rel cadreExt flexContainer"
                                :style="{
                                    width: display.widthExternal + 'px',
                                    height: display.heightExternal + 'px',
                                    zIndex: 1,
                                    border: '2px solid black',
                                    backgroundColor: '#ccc'
                                }"
                                v-if="display.heightExternal !== 0 && display.widthExternal !== 0"
                            >
                                <div class="flexContainer full rel">
                                    <div
                                        id="segmentation"
                                        class="abs"
                                        :style="{ width: display.widthInternal + 'px', height: getSeg.height + 'px', top: display.front + 'px' }"
                                    ></div>
                                </div>
                                <div
                                    class="abs cadreTest flexContainer"
                                    :style="{
                                        width: '100%',
                                        top: display.front + 'px',
                                        bottom: display.base + 'px',
                                        zIndex: 2,
                                        borderTop: '1px solid black',
                                        borderBottom: '1px solid black'
                                    }"
                                    v-if="display.front !== 0"
                                >
                                    <div class="cadre flexContainer" :style="{ width: display.widthInternal + 'px' }">
                                        <div class="margAuto">
                                            <div class="flexContainer">
                                                <div
                                                    class="cadreInt"
                                                    :style="{
                                                        width: display.widthInternal + 'px',
                                                        height: display.heightInternal + 'px',
                                                        zIndex: 1,
                                                        border: '1px solid black',
                                                        backgroundColor: 'white'
                                                    }"
                                                    v-if="
                                                        display.widthInternal !== 0 &&
                                                            display.heightInternal !== 0 &&
                                                            display.heightInternal <= display.heightExternal - display.front - display.base
                                                    "
                                                >
                                                    <div class="abs">
                                                        <div
                                                            class="pitchH"
                                                            v-for="(nbH, index) in parseInt(display.steps[1].repeat)"
                                                            :key="index"
                                                            :style="{
                                                                width: display.steps[1].length + 'px',
                                                                height: display.heightInternal + 'px',
                                                                zIndex: 2,
                                                                borderRight: '1px solid black',
                                                                'border-right-style': 'dotted'
                                                            }"
                                                            v-if="display.steps[1].length * display.steps[1].repeat <= display.widthInternal"
                                                        ></div>
                                                    </div>
                                                    <div class="abs toto" :style="{ width: display.widthInternal + 'px' }">
                                                        <div
                                                            class="pitchV"
                                                            v-for="(nbV, index) in parseInt(display.steps[0].repeat)"
                                                            :key="index"
                                                            :style="{
                                                                width: display.widthInternal + 'px',
                                                                height: display.steps[0].length + 'px',
                                                                zIndex: 2,
                                                                borderBottom: '1px solid black',
                                                                'border-bottom-style': 'dotted'
                                                            }"
                                                            v-if="display.steps[0].length * display.steps[0].repeat <= display.heightInternal"
                                                        ></div>
                                                    </div>
                                                    <div class="abs" v-if="display.blocks.length !== 0">
                                                        <div
                                                            class="pitchV"
                                                            v-for="nbR in parseInt(blockRep)"
                                                            :key="nbR"
                                                            :style="{
                                                                width: display.blocks[0].length + 'px',
                                                                height: display.heightInternal + 'px',
                                                                zIndex: 2,
                                                                borderRight: '2px solid red'
                                                            }"
                                                            v-if="display.blocks[0].length * blockRep <= display.widthInternal"
                                                        ></div>
                                                    </div>
                                                    <!-- <div class="abs" v-else=""> -->
                                                    <!-- <div class="pitchV" v-for="nbR in parseInt(blockRepetition)" -->
                                                    <!--
                                                        :style="{ width: blockLength + 'px', height: display.heightInternal + 'px', zIndex: 2,borderRight: '2px solid red' }"
                                                    -->
                                                    <!-- v-if="(blockLength*blockRepetition) <= display.widthInternal"></div> -->
                                                    <!-- </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h2 v-if="getPicth.x * pitchRepH <= getSizeInt.width" class="fright">
                            &nbsp;{{ $t("meublePlano.remainingSpaceH") }}: {{ getSizeInt.width - getPicth.x * pitchRepH }}
                        </h2>
                        <h2 v-if="getPicth.y * pitchRepV <= getSizeInt.height" class="fright">
                            {{ $t("meublePlano.remainingSpaceV") }}: {{ getSizeInt.height - getPicth.y * pitchRepV }} /
                        </h2>
                    </div>
                </div>
                <button type="button" class="btn pointer saveDisplay uppercase" @click="saveMeuble();">{{ $t("meublePlano.save") }}</button>
            </form>
        </section>
    </section>
</template>

<script>
import httpService from "../service";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            segmentation: null,
            displayType: null,
            blockWidth: 0,
            largeurExt: 0,
            largeurInt: 0,
            hauteurExt: 0,
            hauteurInt: 0,
            widthCadre: 0,
            heightCadre: 0,
            pitchHWidth: 0,
            pitchRepH: 0,
            pitchVWidth: 0,
            pitchRepV: 0,
            display: {},
            range: 1,
            segList: ["45", "100", "70"],
            ratio: 0,
            blockRep: 0,
            blockLength: 0,
            blockRepetition: 0
        };
    },
    computed: {
        getSizeExt() {
            let heightChild = parseInt(this.hauteurExt, 10);
            let widthChild = parseInt(this.largeurExt, 10);
            if (this.ratio === 0) return { width: 0, height: 0 };
            return { width: widthChild * this.ratio, height: heightChild * this.ratio };
        },
        getSizeInt() {
            let heightChild = parseInt(this.heightCadre, 10);
            let widthChild = parseInt(this.widthCadre, 10);
            if (this.ratio === 0) return { width: 0, height: 0 };
            return { width: widthChild * this.ratio, height: heightChild * this.ratio };
        },
        getMargin() {
            let bottomChild = parseInt(this.hauteurInt, 10);
            let topChild = parseInt(this.largeurInt, 10);
            if (this.ratio === 0) return { top: 0, bottom: 0 };
            return { top: topChild * this.ratio, bottom: bottomChild * this.ratio };
        },
        getPicth() {
            let heightChild = parseInt(this.pitchVWidth, 10);
            let widthChild = parseInt(this.pitchHWidth, 10);
            if (this.ratio === 0) return { x: 0, y: 0 };
            return { x: widthChild * this.ratio, y: heightChild * this.ratio };
        },
        getPicthBlock() {
            let widthChild = parseInt(this.blockWidth, 10);
            if (this.ratio === 0) return { width: 0 };
            return { width: widthChild * this.ratio };
        },
        getSeg() {
            let heightChild = parseInt(this.segmentation, 10);
            if (this.ratio === 0) return { height: 0 };
            return { height: heightChild * this.ratio };
        },
        ...mapGetters({
            getDisplayType: "displays/getDisplayType",
            getEditDisplay: "items/getEditDisplay"
        })
    },
    watch: {
        largeurExt(value) {
            this.calculRatio(value);
        },
        hauteurExt(value) {
            this.calculRatio(value);
        }
    },
    methods: {
        calculRatio(value) {
            let heightChild = parseInt(this.hauteurExt, 10);
            let widthChild = parseInt(this.largeurExt, 10);
            let heightParent = this.getSizePlano().height;
            let widthParent = this.getSizePlano().width;
            let ratioH = heightParent / heightChild;
            let ratioW = widthParent / widthChild;
            let ratio = 0;
            if (widthChild === heightChild) {
                if (ratioH < ratioW) {
                    ratio = ratioH;
                } else {
                    ratio = ratioW;
                }
            } else if (widthChild < heightChild) {
                ratio = ratioH;
            } else {
                ratio = ratioW;
            }
            this.ratio = ratio;
        },
        getSizePlano() {
            let planoPreview = document.getElementById("planoPreview");
            if (!planoPreview) {
                return { width: 0, height: 0 };
            }
            let prevHeight = planoPreview.clientHeight;
            let prevWidth = planoPreview.clientWidth;
            return { width: prevWidth, height: prevHeight };
        },
        async saveMeuble() {
            let saveObject = {
                base: this.display.base,
                blocks: [
                    {
                        length: "",
                        repeat: "",
                        orderBy: 1
                    }
                ],
                displayerType: {
                    id: this.display.displayerType.id
                },
                systemType: {
                    id: this.display.systemType.id
                },
                front: this.display.front,
                heightExternal: this.display.heightExternal,
                heightInternal: this.display.heightInternal,
                isRegularHorizontal: this.display.isRegularHorizontal,
                isRegularVertical: this.display.isRegularVertical,
                name: this.display.name,
                segmentation_bar_height: this.display.segmentation_bar_height,
                segmentation_bar_width: this.display.segmentation_bar_width,
                steps: [
                    {
                        length: this.display.steps[0].length,
                        repeat: this.display.steps[0].repeat,
                        active: true,
                        orientation: "vertical"
                    },
                    {
                        length: this.display.steps[1].length,
                        repeat: this.display.steps[0].repeat,
                        active: true,
                        orientation: "horizontal"
                    }
                ],
                widthExternal: this.display.widthExternal,
                widthInternal: this.display.widthInternal
            };
            if (this.display.blocks.length !== 0) {
                saveObject.blocks[0].repeat = this.blockRep;
                saveObject.blocks[0].length = this.display.blocks[0].length;
            } else {
                saveObject.blocks[0].repeat = this.blockRepetition;
                saveObject.blocks[0].length = this.blockLength;
            }
            try {
                const resp = await httpService.put("/admin/displayers/" + this.display.id, JSON.stringify(saveObject));
                if (resp.code) {
                    throw resp.message;
                }
                this.dialogSuccess("ENREGISTREE AVEC SUCCES");
                this.$router.push("/displayers");
            } catch (e) {
                this.dialogError(e);
            }
        }
    },
    mounted() {},
    created() {
        this.$store.dispatch("displays/getDisplayType").then(() => {});
        httpService.get("/admin/displayers/" + this.getEditDisplay).then(res => {
            this.display = res;
            this.blockRep = this.display.widthInternal / this.display.blocks[0].length;
            if (this.blockRep === Infinity) {
                this.blockRep = 0;
            } else {
            }
        });
    }
};
</script>

<style lang="scss" scoped>
#meublePlano {
    margin-top: 10px;
    background-color: white;
    border-radius: 3px;
    #meublePlanoWrapper {
        padding: 30px 30px 30px 30px;
        .plano {
            padding-top: 30px;
            .formBuilder {
                max-width: 430px;
                margin-right: 30px;
                height: calc(100vh - 300px);
                padding-right: 15px;
                .formGroup {
                    width: inherit;
                    input {
                        height: 30px;
                        font-size: 14px;
                        padding-left: 10px;
                        margin-bottom: 15px;
                    }
                    .label {
                        font-size: 14px;
                        font-family: "Roboto", sans-serif;
                        padding-bottom: 5px;
                    }
                    h3 {
                        color: #666;
                    }
                    #selectSeg {
                        height: 30px;
                        margin-bottom: 20px;
                        font-size: 1.4rem;
                    }
                }
            }
        }
    }
    .planoMeuble {
        #planoPreview {
            width: 0px;
        }
        .cadreExt,
        .cadreTest {
            #segmentation {
                background: #343434;
                margin: auto;
                left: 0;
                right: 0;
                padding: 0 15px;
                .segName {
                    color: #fff;
                    height: 25px;
                    line-height: 25px;
                }
            }
            .cadre {
                .cadreInt {
                    margin: auto;
                    overflow: hidden;
                    .pitchH {
                        display: inline-block;
                    }
                    .pitchV {
                        display: inline-block;
                    }
                }
            }
        }
    }
}

.formGroup {
    width: 140%;
}

.divDroite {
    margin-left: 10px;
}

.blockName {
    width: 50%;
}
</style>



// WEBPACK FOOTER //
// EditDisplayer.vue?991f1a32